module.exports = __webpack_public_path__ + "static/60a31baf88b955e26f54414796b7acae2ef51b47e70e8278d67fb0c532a9436f-917ac37edc80a44a03aedeafe4167f59.png";